// import response from './exampleResponse';

const ALLOWED_VEHICLE_IDS = {
  2: true,
  3: true,
  4: true,
  5: true,
  6: true,
  8: true,
  9: true,
  11: true,
  13: true,
  16: true,
  18: true,
  20: true,
  102: true,
  103: true,
  104: true,
  105: true,
  106: true,
  107: true,
  109: true,
  110: true,
};

const KIWITAXI_PROVIDER_NAME = 'kiwitaxi';

const isAllowedVehicle = ({ vehicle: { vehicle_type: vehicleType } }) => (
  vehicleType.key in ALLOWED_VEHICLE_IDS && ALLOWED_VEHICLE_IDS[vehicleType.key]
);

/**
 * @param {Array} result - результат convertToFlat()
 * @param {*} transfers
 */
const sortByPrice = result => [...result]
  .sort(({ price: A }, { price: B }) => Number(A.price.value) - Number(B.price.value));

export const isNotKiwiTaxiProvider = ({ provider: { name } }) => (
  name.toLowerCase() !== KIWITAXI_PROVIDER_NAME
);

const normalizeAmenities = (amenities = []) => amenities.map(item => ({
  name: item.name,
  imageUrl: item.image_url,
  included: item.included,
  selected: item.selected,
}));

export const convertToFlat = results => results.map(item => ({
  resultId: item.result_id,
  vehicleId: item.vehicle_id,
  price: item.steps[0].details.price,
  vehicle: item.steps[0].details.vehicle,
  /**
   * нет провайдера
   */
  provider: item.steps[0].details.provider || { name: KIWITAXI_PROVIDER_NAME },
  departureDatetime: item.steps[0].details.departure_datetime,
  cancellation: item.steps[0].details.cancellation,
  waitTime: item.steps[0].details.wait_time,
  /** Допники */
  amenities: normalizeAmenities(item.steps[0].details.amenities),
  tags: item.tags || [],
}));

/**
 * @param {Array} result - результат convertToFlat()
 * @returns {Array}
 */
export const filterResult = result => filters => result
  .filter(normalizedItem => [...filters, isAllowedVehicle].every(fn => fn(normalizedItem)));

/**
 * @param {Array} result - результат convertToFlat()
 * @param {*} transfers
 */
export const groupByCategories = transfers => transfers
  .reduce((acc, transfer) => {
    const { name } = transfer.vehicle.category;
    if (name in acc) {
      acc[name].transfers.push(transfer);
    } else {
      acc[name] = {
        name,
        transfers: [transfer],
      };
    }
    return acc;
  }, {});

export const sortGroupByPrice = groups => Object.values(groups)
  // сортировка внутри группы
  .map(group => sortByPrice(group.transfers))
  // сортировка групп
  .sort((a, b) => a[0].price.price.value - b[0].price.price.value);

export const normalizeVehicles = vehicles => vehicles.reduce((acc, next) => {
  acc[next.vehicle_id] = next;
  return acc;
}, {});
